export const technicalSkillsData = [
    { 
        name: "BulMar Office", 
        description: "Счетоводство+, ТРЗ",
        icon: "fa-calculator",
        link: "https://bulmar.com/bg/accounting-software"
    },
    { 
        name: "ERP система", 
        description: "Кредо 2000",
        icon: "fa-database"
    },
    { 
        name: "CRM системи", 
        description: "Клиентски взаимоотношения",
        icon: "fa-handshake"
    },
    { 
        name: "MS Office", 
        description: "Excel, Word, Outlook",
        icon: "fa-file-excel"
    }
];